import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { ThreadCreateFormComponent } from './ThreadCreateForm'
import { push } from 'react-router-redux'
import { flow, get } from 'lodash'
import showNumbersFormModal from 'features/Numbers/NumbersFormModal'

export const formName = 'threadCreate'

export interface IThreadCreateFormContainerProps {
  onCancel: () => undefined
  onConfirm: () => undefined
}

const stateToProps = ({ form }) => ({
  formData: get(form, `${formName}.values`, {}),
})

export const dispatchToProps = {
  push,
  showNumbersFormModal,
}

export const ThreadCreateForm = flow<any, any, React.SFC<IThreadCreateFormContainerProps>>(
  reduxForm({ form: formName, enableReinitialize: true }),
  connect(stateToProps, dispatchToProps)
)(ThreadCreateFormComponent)



// WEBPACK FOOTER //
// src/features/Messages/ThreadCreateForm/ThreadCreateForm.container.ts